import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafeHtmlPipe } from './safe-html.pipe'; 
import { TranslatePipe } from './translate.pipe';


@NgModule({
  declarations: [
    SafeHtmlPipe,
    TranslatePipe
  ],
  imports: [
    CommonModule, 
  ],
  exports : [
    SafeHtmlPipe,
    TranslatePipe
  ]
})
export class PipesModule { }
